import { forwardRef, type HTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const contentContainerVariants = cva('w-full mx-auto', {
  variants: {
    maxWidth: {
      // Default: 1100 px centered ab Desktop. Matches Sönkes TopBar Page-Content-Cap.
      // Mobile/Tablet: full-width mit Standard-Padding (20 px / 40 px).
      default: 'px-5 md:px-10 desktop:max-w-[1100px] desktop:px-0.5',
      // Nav: 768 px Desktop-Cap für BottomNav (enger gepackte Nav-Items).
      nav: 'px-5 md:px-10 desktop:max-w-[768px]',
      // Narrow: für Forms (Signup, Kinderprofil-Create, Password-Reset).
      narrow: 'px-5 md:px-10 desktop:max-w-[600px]',
      // Full: Hero-Sections, Image-Carousels — keine max-width auf Desktop.
      full: 'px-5 md:px-10',
    },
  },
  defaultVariants: {
    maxWidth: 'default',
  },
});

export interface ContentContainerProps
  extends HTMLAttributes<HTMLDivElement>, VariantProps<typeof contentContainerVariants> {}

export const ContentContainer = forwardRef<HTMLDivElement, ContentContainerProps>(
  ({ className, maxWidth, ...props }, ref) => (
    <div ref={ref} className={cn(contentContainerVariants({ maxWidth }), className)} {...props} />
  ),
);
ContentContainer.displayName = 'ContentContainer';
